import request from '@/utils/request'

// 查询收款管理列表
export function listsq(query) {
  return request({
    url: '/xm/shenhe/mysqlist',
    method: 'get',
    params: query
  })
}
export function listSqmx(query) {
  return request({
    url: '/system/data/sqmx',
    method: 'get',
    params: query
  })
}
export function listysh(query) {
  return request({
    url: '/xm/shenhe/myyshlist',
    method: 'get',
    params: query
  })
}
export function listdqsh(query) {
  return request({
    url: '/xm/shenhe/mydqshlist',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/xm/shenhe.js